import React from 'react';
import { StarIcon } from 'lucide-react';
export function Chapter7() {
  return <section className="py-8 border-t border-gray-200" data-id="element-194">
      <h2 className="text-2xl font-bold mb-6" data-id="element-195">
        Röster från andra (vanliga människor, vanliga dagar)
      </h2>
      <p className="mb-4 text-lg" data-id="element-196">
        Jag bad runt efter erfarenheter som lät som mina – inga superlativ, bara
        vardag.
      </p>
      <div className="space-y-6 my-6" data-id="element-197">
        <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-198">
          <div className="flex mb-2" data-id="element-199">
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-200" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-201" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-202" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-203" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-204" />
          </div>
          <p className="text-lg mb-2" data-id="element-205">
            "Efter tre veckor skrev jag färre listor. Jag är 68 och känner mig
            mentalt skarpare."
          </p>
          <p className="text-sm text-gray-600" data-id="element-206">
            Gunilla, 68 år - Verifierad kund
          </p>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-207">
          <div className="flex mb-2" data-id="element-208">
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-209" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-210" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-211" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-212" />
            <StarIcon className="h-5 w-5 text-gray-300" data-id="element-213" />
          </div>
          <p className="text-lg mb-2" data-id="element-214">
            "Stabil och pålitlig. Inga mirakel, men märkbar skillnad."
          </p>
          <p className="text-sm text-gray-600" data-id="element-215">Lars, 57 år - Verifierad kund</p>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-216">
          <div className="flex mb-2" data-id="element-217">
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-218" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-219" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-220" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-221" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-222" />
          </div>
          <p className="text-lg mb-2" data-id="element-223">
            "Som lärare behöver jag orka vara närvarande. Brainy hjälper mig
            hålla fokus under långa dagar."
          </p>
          <p className="text-sm text-gray-600" data-id="element-224">
            Marianne, 52 år - Verifierad kund
          </p>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-225">
          <div className="flex mb-2" data-id="element-226">
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-227" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-228" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-229" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-230" />
            <StarIcon className="h-5 w-5 text-gray-300" data-id="element-231" />
          </div>
          <p className="text-lg mb-2" data-id="element-232">
            "Tog paus efter första burken. Märkte skillnad – började igen."
          </p>
          <p className="text-sm text-gray-600" data-id="element-233">
            Bengt, 64 år - Verifierad kund
          </p>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-234">
          <div className="flex mb-2" data-id="element-235">
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-236" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-237" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-238" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-239" />
            <StarIcon className="h-5 w-5 text-yellow-500" data-id="element-240" />
          </div>
          <p className="text-lg mb-2" data-id="element-241">
            "Morgondimman gav med sig. Jag är med från start."
          </p>
          <p className="text-sm text-gray-600" data-id="element-242">
            Annika, 59 år - Verifierad kund
          </p>
        </div>
      </div>
    </section>;
}